import { render, staticRenderFns } from "./bottombar.vue?vue&type=template&id=7d44c39c&scoped=true&"
import script from "./bottombar.vue?vue&type=script&lang=js&"
export * from "./bottombar.vue?vue&type=script&lang=js&"
import style0 from "./bottombar.vue?vue&type=style&index=0&id=7d44c39c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d44c39c",
  null
  
)

export default component.exports